/* eslint-disable @typescript-eslint/no-explicit-any */
import Handlebars from 'handlebars/dist/handlebars';
export function createHandlebarsInstance() {
    const handlebars = Handlebars.create();
    handlebars.registerHelper('ifEq', function (...args) {
        for (let i = 1; i < args.length - 1; i++) {
            if (args[i] !== args[0]) {
                return;
            }
        }
        const options = args[args.length - 1];
        if (options.fn) {
            return options.fn(this);
        }
    });
    handlebars.registerHelper('ifTrue', function (...args) {
        for (let i = 0; i < args.length - 1; i++) {
            if (args[i] !== true) {
                return;
            }
        }
        const options = args[args.length - 1];
        if (options.fn) {
            return options.fn(this);
        }
    });
    handlebars.registerHelper('ifTruthy', function (...args) {
        for (let i = 0; i < args.length - 1; i++) {
            if (args[i]) {
                return;
            }
        }
        const options = args[args.length - 1];
        if (options.fn) {
            return options.fn(this);
        }
    });
    handlebars.registerHelper('ifFalse', function (...args) {
        for (let i = 0; i < args.length - 1; i++) {
            if (args[i] !== false) {
                return;
            }
        }
        const options = args[args.length - 1];
        if (options.fn) {
            return options.fn(this);
        }
    });
    handlebars.registerHelper('ifFalsy', function (...args) {
        for (let i = 0; i < args.length - 1; i++) {
            if (!args[i]) {
                return;
            }
        }
        const options = args[args.length - 1];
        if (options.fn) {
            return options.fn(this);
        }
    });
    handlebars.registerHelper('ifNull', function (...args) {
        for (let i = 0; i < args.length - 1; i++) {
            if (args[i] != null) {
                return;
            }
        }
        const options = args[args.length - 1];
        if (options.fn) {
            return options.fn(this);
        }
    });
    handlebars.registerHelper('isTrue', function (...args) {
        for (let i = 0; i < args.length - 1; i++) {
            if (args[i] !== true) {
                return false;
            }
        }
        return true;
    });
    handlebars.registerHelper('isTruthy', function (...args) {
        for (let i = 0; i < args.length - 1; i++) {
            if (args[i]) {
                return false;
            }
        }
        return true;
    });
    handlebars.registerHelper('isFalse', function (...args) {
        for (let i = 0; i < args.length - 1; i++) {
            if (args[i] !== false) {
                return false;
            }
        }
        return true;
    });
    handlebars.registerHelper('isFalsy', function (...args) {
        for (let i = 0; i < args.length - 1; i++) {
            if (!args[i]) {
                return false;
            }
        }
        return true;
    });
    handlebars.registerHelper('isNull', function (...args) {
        for (let i = 0; i < args.length - 1; i++) {
            if (args[i] != null) {
                return false;
            }
        }
        return true;
    });
    handlebars.registerHelper('eq', function (...args) {
        for (let i = 1; i < args.length - 1; i++) {
            if (args[i] !== args[0]) {
                return false;
            }
        }
        return true;
    });
    handlebars.registerHelper('concat', function (...args) {
        let result = '';
        for (let i = 1; i < args.length - 1; i++) {
            result += args[i];
        }
        return result;
    });
    handlebars.registerHelper('value', function (...args) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (args.length > 1) {
            const options = args[args.length - 1];
            const handler = (_b = (_a = options.data) === null || _a === void 0 ? void 0 : _a.root) === null || _b === void 0 ? void 0 : _b['_internal_handler_'];
            if (handler != null) {
                return ((_d = (_c = handler
                    .select(args[0])) === null || _c === void 0 ? void 0 : _c.getLabelValueAsTextPairs().map(({ text }) => text).filter((text) => !!text).join(', ')) !== null && _d !== void 0 ? _d : '');
            }
            else if (args.length > 2) {
                return args[1];
            }
            else {
                return (_h = (_g = (_f = (_e = options.data) === null || _e === void 0 ? void 0 : _e.root) === null || _f === void 0 ? void 0 : _f['_internal_values_']) === null || _g === void 0 ? void 0 : _g[args[0]]) !== null && _h !== void 0 ? _h : args[0];
            }
        }
    });
    handlebars.registerHelper('formData', function (...args) {
        var _a, _b;
        const options = args[args.length - 1];
        const handler = (_b = (_a = options.data) === null || _a === void 0 ? void 0 : _a.root) === null || _b === void 0 ? void 0 : _b['_internal_handler_'];
        if (handler != null) {
            return handler.formData;
        }
        else {
            return undefined;
        }
    });
    handlebars.registerHelper('formParams', function (...args) {
        var _a, _b;
        const options = args[args.length - 1];
        const handler = (_b = (_a = options.data) === null || _a === void 0 ? void 0 : _a.root) === null || _b === void 0 ? void 0 : _b['_internal_handler_'];
        if (handler != null) {
            return handler.formParams;
        }
        else {
            return undefined;
        }
    });
    handlebars.registerHelper('pre', function (...args) {
        if (args.length > 1) {
            const data = args.length === 2 ? args[0] : args.slice(0, -1);
            return new Handlebars.SafeString('<pre>' +
                Handlebars.escapeExpression(JSON.stringify(Object.assign(Object.assign({}, data), { _internal_handler_: undefined, _internal_values_: undefined }), undefined, '  ')) +
                '</pre>');
        }
    });
    return handlebars;
}
